import { useState, useEffect } from 'react';

import { handleAxiosError } from 'core/notifications';

import axios from '@/util/axios';

export default () => {
  const [isLoading, setIsLoading] = useState(true);
  const [model, setModel] = useState({
    radioOptions: 'template',
  });

  const [letters, setLetters] = useState([]);

  const fetchLetters = async () => {
    try {
      const res = await axios.get('/api/admin/letters');
      setLetters(res.data.data);
      setIsLoading(false);
    } catch (error) {
      return handleAxiosError(error);
    }
  };

  useEffect(() => {
    fetchLetters();
  }, []);

  const onUpdateModel = ({ update }) => {
    setModel({ ...model, ...update });
  };

  return {
    isLoading,
    model,
    onUpdateModel,
    letters,
  };
};
